module.exports = __webpack_public_path__ + "img/139.4.2a551cbb.png";